import { useTranslate } from '_core/hooks/useTranslate';
import PropTypes from 'prop-types';
import React from 'react';
import Image from '../Image';

const LoadingDots = ({ loadingText, loadingPic }) => {
  const { t } = useTranslate();
  return (
    <div className="loading-dots">
      {loadingPic && <Image className="loading-dots__img" src={loadingPic} alt={t('alt:Loading')} />}
      {loadingText && <p className="loading-dots__text">{loadingText}</p>}
      <div className="loading-dots__loader">
        <div className="loading-dots__dot-one"></div>
        <div className="loading-dots__dot-two"></div>
        <div className="loading-dots__dot-three"></div>
      </div>
    </div>
  );
};

LoadingDots.propTypes = {
  loadingText: PropTypes.string,
  loadingPic: PropTypes.string,
};

LoadingDots.defaultProps = {
  loadingText: '',
};

export default LoadingDots;
